module.exports = __webpack_public_path__ + "static/media/Group 53611.0fb17252.svg";